// For first party app ids, please ensure the values map to the corresponding ids in FirstPartyWorkloadIds.ts without the "Shell" prefix.
// For example, "ShellWordOnline" => "WordOnline"
export var HubTileID = {
    home: '5099F2E5-AD99-4BF2-BF82-DF525FFD0BE2',
    create: '83D3F491-B586-4266-8738-89776471BF21',
    mycontent: 'F57D5D29-4967-495C-A648-F7AB66BF8572',
    orion: '099317ab-9a66-4a75-868c-dc2263ce2eb9',
    intents: '2CC62124-219E-4777-9A92-00CDE9062859',
    feed: '261d33d6-15ba-4e1d-b298-8096960fab40',
    appgallery: '26706956-2AAE-4A22-8960-09B98C35B28C',
    alps: '4fbe3a87-55c7-45f6-a518-462f40fd25a0',
    outlook: 'Mail',
    onedrive: 'Documents',
    teams: 'SkypeTeams',
    word: 'WordOnline',
    excel: 'ExcelOnline',
    powerpoint: 'PowerPointOnline',
    onenote: 'OneNoteOnline',
    sway: 'Sway',
    forms: 'OfficeForms',
    admin: 'Admin',
    visio: 'VisioOnline',
    stream: 'MicrosoftStream',
    todo: 'ToDo',
    familysafety: 'FamilySafety',
    calendar: 'Calendar',
    skype: 'Skype',
    people: 'People',
    powerautomate: 'LogicFlows',
    clipchamp: 'Clipchamp',
    lists: 'Lists',
    yammer: 'Yammer',
    powerbi: 'PowerBIv2',
    bing: 'Bing',
    msn: 'MSN',
    privacy: 'Privacy',
    rewards: 'Rewards',
    whiteboard: 'Whiteboard',
    defender: 'Defender',
};
//# sourceMappingURL=HubTileID.js.map